// Module
var code = `<h2 class="section-header">Please confirm the following:</h2>
<form name="\$ctrl.lookupForm">
  <table class="misc-transaction__table table table--generate-row-ids">
    <tbody>
    <tr>
      <td></td>
      <td>Individual SSS number:</td>
      <td>
        <input
          required
          ng-model="\$ctrl.sssNumber"
          ui-mask="99-9999999-9"
          ng-pattern="\$ctrl.ssNumberPattern()"
          type="text"
          name="sssNumber"
        />
      </td>
      <td>
        <button
          type="submit"
          class="btn btn-success"
          ng-disabled="\$ctrl.lookupForm.\$invalid"
          ng-click="\$ctrl.fetchBySsn()">
          Lookup PRN
        </button>
      </td>
    </tr>
    </tbody>
  </table>
  <div>
    <table class="misc-transaction__table table table--generate-row-ids" ng-if="\$ctrl.payments && \$ctrl.payments.length > 0">
      <thead>
      <tr>
        <th>No.</th>
        <th>SSS number</th>
        <th>Payor name</th>
        <th>PRN</th>
        <th>Amount</th>
        <th>Start period</th>
        <th>End period</th>
      </tr>
      </thead>
      <tbody>
        <tr ng-repeat="payment in \$ctrl.payments">
          <td></td>
          <td>{{payment.ssNumber}}</td>
          <td>{{payment.payorName}}</td>
          <td>{{payment.paymentReferenceNumber}}</td>
          <td>{{payment.amount | nxCurrency}}</td>
          <td>{{payment.startingPeriod | prettyYearMonth}}</td>
          <td>{{payment.endingPeriod | prettyYearMonth}}</td>
        </tr>
      </tbody>
    </table>
    <div class="text-center empty-message" ng-if="\$ctrl.payments && \$ctrl.payments.length === 0">
      No SSS payments found
    </div>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/miscellaneous-transactions/sss-online-payment/sss-lookup-prn.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;